import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/home/index.vue";
import NodeView from "../views/node/index.vue";
import ExchangeView from "../views/exchange/index.vue";
import MeView from "../views/me/index.vue";
import RechargeView from "../views/me/recharge.vue";
import TransferView from "../views/me/transfer.vue";
import RecordView from "../views/me/record.vue";
import Release from "../views/release/index.vue";
import Defiview from "../views/defi/index.vue";
import Layout from "@/layout/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "layout",
    component: Layout,
    redirect: "/home",
    children: [
      {
        path: "/home",
        name: "home",
        component: HomeView,
        meta: { name: "home" }
      },
      {
        path: "/node",
        name: "node",
        component: NodeView,
        meta: { name: "node" }
      },
      {
        path: "/exchange",
        name: "exchange",
        component: ExchangeView,
        meta: { name: "exchange" }
      },
      {
        path: "/me",
        name: "me",
        component:MeView,
        meta: { name: "me" }
      },
       {
        path: "/recharge",
        name: "recharge",
        component:RechargeView,
        meta: { name: "recharge" }
      },
      {
        path: "/defi",
        name: "defi",
        component:Defiview,
        meta: { name: "defi" }
      },
      {
        path: "/transfer",
        name: "transfer",
        component: TransferView,
        meta: { name: "transfer" }
      },
      {
        path: "/record",
        name: "record",
        component: RecordView,
        meta: { name: "record" }
      },
      {
        path: "/release",
        name: "release",
        component: Release,
        meta: { name: "release" }
      },
    ],
  },
];

// 保存原始方法
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

// 重写 push 方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    // 处理重复路由跳转的错误
    if (err.name !== 'NavigationDuplicated') {
      // 如果不是重复跳转错误，将错误继续抛出
      throw err;
    }
  });
};

// 重写 replace 方法
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  });
};

const router = new VueRouter({
  //mode: "history",
  base: process.env.BASE_URL,
  routes,
});
router.afterEach(() => {
  // 平滑滚动到顶部（兼容大部分浏览器）
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
})
export default router;
